module.exports = __webpack_public_path__ + "static/media/i3a.1a476978.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i3a.svg
// module id = 194
// module chunks = 12